import React from "react";
import axios from "axios";

const url = "https://redemeaiyg.execute-api.us-east-1.amazonaws.com/user";

const getUserInfoQuery = `
  query GetUserInfo {
    getUserInfo {
        status
        errors
        data {
            email
            fullName
            PK
            SK
            type
        }
    }
  }
`;

const updateUserInfoMutation = `
  mutation UpdateUserProfile($input: UpdateUserProfileInput!) {
    updateUserProfile(input: $input) {
        status
        errors
        data {
            PK
            SK
            fullName
            email
        }
    }
  }
`


function Profile() {
  const [data, setData] = React.useState({
    fullName: "",
    email: "",
  });
  const [errors, setErrors] = React.useState<string[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [disabled, setDisabled] = React.useState(true);

  React.useEffect(() => {
    setLoading(true);
    const graphqlQuery = {
      query: getUserInfoQuery,
    };
    const token = localStorage.getItem("token");
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .post(`${url}`, graphqlQuery, config)
      .then((res) => {
        const data = res.data.data.getUserInfo;
        if (data.status > 199 && data.status < 300) {
          setData({ fullName: data.data.fullName, email: data.data.email });
        } else {
          setErrors(data.errors);
        }
      })
      .catch((err) => {
        setErrors([err.message]);
      })
      .finally(() => setLoading(false));
      return () => {
        setData({ fullName: "", email: "" });
        setErrors([]);
        setLoading(false);
        setDisabled(true);
      }
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
    setDisabled(false);
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    setDisabled(true);
    const graphqlQuery = {
      query: updateUserInfoMutation,
      variables: {
        input: {
          fullName: data.fullName,
          email: data.email,
        },
      },
    };
    const token = localStorage.getItem("token");
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .post(`${url}`, graphqlQuery, config)
      .then((res) => {
        const data = res.data.data.updateUserProfile;
        if (data.status > 199 && data.status < 300) {
          setErrors([]);
          setDisabled(true);
          setData({ fullName: data.data.fullName, email: data.data.email });
        } else {
          setErrors(data.errors);
        }
      }).catch((err) => {
        setErrors([err.message]);
      }).finally(() => setLoading(false));
  }

  if (loading) {
    return (
      <div>
        <h1>Loading...</h1>
      </div>
    );
  }

  if (errors.length > 0) {
    return (
      <div>
        <h1>Error</h1>
        <p>{errors[0]}</p>
      </div>
    );
  }

  return (
    <div>
      <h1>Edit Profile</h1>
      <form className="form" onSubmit={handleSubmit}>
        <label htmlFor="fName">Full Name</label>
        <input
          id="fName"
          type="text"
          placeholder="Name"
          name="fullName"
          value={data.fullName}
          onChange={handleChange}
        />
        <label htmlFor="email">Email</label>
        <input
          id="email"
          type="email"
          placeholder="Email"
          name="email"
          value={data.email}
          onChange={handleChange}
        />
        <button type="submit" className="btn-primary" disabled={disabled}>
          Save
        </button>
      </form>
    </div>
  );
}

export default Profile;
